import {createId} from './seed';

export const isValidSessionId=(value)=> typeof value==='string' && value.trim().length>0;

const describePayload=(payload)=> ({
  id: payload?.id ?? null,
  guide_id: payload?.guide_id ?? null,
  trip_type_id: payload?.trip_type_id ?? null,
  date: payload?.date ?? null,
  start_time: payload?.start_time ?? null,
  capacity: payload?.capacity ?? null,
  status: payload?.status ?? null
});

export const createSessionId=()=> createId('session');

export const buildSessionPayload=(values,{id,createdAt}={})=> {
  const sessionId=id ?? values?.id;

  if (!isValidSessionId(sessionId)) {
    throw new Error(
      `Invalid fishing session id before persistence. Received ${JSON.stringify({
        operation: 'buildSessionPayload',
        values: describePayload(values)
      })}`
    );
  }

  return {
    id: sessionId,
    guide_id: values.guide_id || 'guide_demo',
    trip_type_id: values.trip_type_id,
    date: values.date,
    start_time: values.start_time,
    capacity: Number(values.capacity),
    status: values.status || 'OPEN',
    notes: values.notes || '',
    calendar_conflict_status: values.calendar_conflict_status || 'NOT_CONNECTED',
    created_at: createdAt || values.created_at || new Date().toISOString(),
    updated_at: new Date().toISOString()
  };
};

export const assertSessionWritePayload=(payload,operation)=> {
  if (!isValidSessionId(payload?.id)) {
    const diagnostic={
      operation,
      payload: describePayload(payload),
      message: 'A fishing_sessions write was blocked because its id was null, undefined, or empty.'
    };

    console.error('[SOSBooking session integrity]',diagnostic);
    throw new Error(`${diagnostic.message} Operation: ${operation}.`);
  }

  return payload;
};

export const assertSessionRowsHaveIds=(sessions,operation='loadData')=> {
  const invalid=(sessions || []).find((session)=> !isValidSessionId(session?.id));

  if (invalid) {
    const diagnostic={
      operation,
      invalidSession: describePayload(invalid)
    };

    console.error('[SOSBooking session integrity]',diagnostic);
    throw new Error(
      `Persistent booking data contains a fishing session without a valid id. Operation: ${operation}.`
    );
  }

  return sessions;
};